// client/src/modules/new-year-tree-3d/Tree3dBootScreen.tsx
import { BootScreen } from '../../shared/coloring-kit/status/BootScreen';

import { tree3dProduct } from './product';

/** Заставка 3D-ёлки: общий `BootScreen` кита со знаком и названием продукта. */
export function Tree3dBootScreen({ text = 'Наряжаем ёлку…', hidden = false }: { text?: string; hidden?: boolean }) {
  return <BootScreen brand={tree3dProduct.brand} text={text} hidden={hidden} theme="winter" />;
}
